import {
  doc,
  setDoc,
  updateDoc,
  collection,
  arrayUnion,
  Timestamp
} from 'firebase/firestore';
import { onSnapshotWithRetry as onSnapshot } from '../utils/firestoreSubscribe';
import { getDb } from '../firebase';
import { DEFAULT_CHILD_COLORS } from '../utils/constants';

export const addChild = async (familyId, childData, existingChildCount = 0) => {
  const db = getDb();
  const ref = doc(collection(db, 'families', familyId, 'children'));
  const data = {
    ...childData,
    color: childData.color || DEFAULT_CHILD_COLORS[existingChildCount % DEFAULT_CHILD_COLORS.length].hex,
    createdAt: Timestamp.now()
  };
  await setDoc(ref, data);

  await updateDoc(doc(db, 'families', familyId), {
    childrenIds: arrayUnion(ref.id)
  });

  return { id: ref.id, ...data };
};

export const updateChild = async (familyId, childId, updates) => {
  const db = getDb();
  await updateDoc(doc(db, 'families', familyId, 'children', childId), updates);
};

export const subscribeToChildren = (familyId, callback) => {
  const db = getDb();
  return onSnapshot(
    collection(db, 'families', familyId, 'children'),
    (snapshot) => {
      const children = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      callback(children);
    },
    (error) => {
      console.error('Children listener error:', error);
    }
  );
};
